import {
	DefaultButton,
	DialogFooter,
	PrimaryButton,
	Stack,
} from '@fluentui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { EntityType, IGenericEntity, ITaskRequestFilterField } from '../../API';
import EntityDashboardState from '../../state/EntityDashboardState';
import { IUserConfigPackage } from '../../API';
import EntityDashboard from '../dashboards/EntityDashboard';
import GenericDialog from '../pages/GenericDialog';

export interface IEntitySelectorDialogProps {
	dialogTitle: string;
	entityType: EntityType | string;
	userConfig: IUserConfigPackage;
	permaFilters?: ITaskRequestFilterField[];
	onSelect: (items: IGenericEntity[]) => void;
	onCancel: () => void;
	visible: boolean;
	multi: boolean;
}

interface IEntitySelectorDialogState {
	selectedItems: IGenericEntity[];
	dashboard: EntityDashboardState;
}

class EntitySelectorDialogCtrl extends React.Component<
	IEntitySelectorDialogProps,
	IEntitySelectorDialogState
> {
	constructor(props: IEntitySelectorDialogProps) {
		super(props);
		this.state = {
			selectedItems: [],
			dashboard: new EntityDashboardState(
				this.props.entityType,
				this.props.userConfig,
				true,
				true,
			),
		};

		if (this.props.permaFilters) {
			this.state.dashboard.setPermaFilters(this.props.permaFilters);
		}
	}

	render() {
		if (!this.props.visible) {
			return <></>;
		}

		return (
			<>
				<GenericDialog
					fullScreen={false}
					visible={true}
					onDismiss={() => {
						this.props.onCancel();
					}}
					title={this.props.dialogTitle}
				>
					<Stack>
						<EntityDashboard
							state={this.state.dashboard}
							/* item double-click selects it immediately and closes the dialog */
							onItemInvoked={(item) => this.props.onSelect([item])}
							singleSelect={!this.props.multi}
							onSelectionChanged={(items: IGenericEntity[]) => {
								this.setState({ selectedItems: items });
							}}
						/>

						{this.props.children}

						<DialogFooter>
							<DefaultButton
								onClick={() => {
									this.props.onCancel();
								}}
							>
								Cancel
							</DefaultButton>
							<PrimaryButton
								disabled={this.state.selectedItems.length === 0}
								onClick={() => {
									this.props.onSelect(this.state.selectedItems);
								}}
							>
								Select
							</PrimaryButton>
						</DialogFooter>
					</Stack>
				</GenericDialog>
			</>
		);
	}
}

export default observer(EntitySelectorDialogCtrl);
